"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// / <reference types="chrome"/>
const vue_1 = require("vue");
const index_vue_1 = require("./index.vue");
(0, vue_1.createApp)(index_vue_1.default).mount('#app');
